import { ActionReducerMap } from '@ngrx/store';
import * as fromOffers from './offers.reducer';
import * as fromComparisons from './comparisons.reducer';
import * as fromOfferReference from './offer.reference.reducer';
import * as fromLandingModal from './landing.modal.reducer';
import * as fromDeliveryDates from './offers.delivery.dates.reducer';
import * as fromOptimizely from './optimizely.reducer';
export interface ViewOffersState {
  readonly offerReference: fromOfferReference.OfferReferenceState;
  readonly offers: fromOffers.OffersState;
  readonly comparisons: fromComparisons.ComparisonsState;
  readonly landingModal: fromLandingModal.LandingModalState;
  readonly offersDeliveryDates: fromDeliveryDates.OffersDeliveryDatesState;
  readonly optimizely: fromOptimizely.OptimizelyState;
}

export const viewOffersReducers: ActionReducerMap<ViewOffersState> = {
  offerReference: fromOfferReference.reducer,
  offers: fromOffers.reducer,
  comparisons: fromComparisons.reducer,
  landingModal: fromLandingModal.reducer,
  offersDeliveryDates: fromDeliveryDates.reducer,
  optimizely: fromOptimizely.reducer,
};

export const VIEW_OFFERS_FEATURE = 'viewOffers';
